module.exports = __webpack_public_path__ + "static/img/mb-about.b83d96a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mobile/mb-about.jpg
// module id = 1V60
// module chunks = 1